import TemplateView from '../../../TemplateView'

export default class LockoutSettingsDetailsPopup extends TemplateView {

    templateHtml() {
        return `
<div class='lockoutSettingsDetailsPopup'>
    <div class='durationBlock note'><%=durationBlock%></div>
    <div class='thresholdBlock note'><%=thresholdBlock%></div>
    <div class='counterBlock note'><%=counterBlock%></div>
    <div class='zeroRuleBlock note last'><%=zeroRuleBlock%></div>
</div>
`
    }

    messageKeys() {
        return {
            durationBlock: 'lockout_policy.settings.details_popup.duration_block',
            thresholdBlock: 'lockout_policy.settings.details_popup.threshold_block',
            counterBlock: 'lockout_policy.settings.details_popup.counter_block',
            zeroRuleBlock: 'lockout_policy.settings.details_popup.zero_button_block',
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/lockoutPolicy/components/LockoutSettingsDetailsPopup.js